// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Desplegable de clientes. Acotado a .client-picker: el CSS de CRA es global. */
.client-picker { position: relative; }
.client-picker input { width: 100%; }

.client-picker-lista {
  position: absolute;
  z-index: 20;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 260px;
  overflow-y: auto;
  margin: 0;
  padding: 4px;
  list-style: none;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.client-picker-lista li { margin: 0; }

.client-picker .client-picker-lista button {
  display: block;
  width: 100%;
  padding: 7px 10px;
  border: none;
  border-radius: 6px;
  background: none;
  color: #222;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}

.client-picker .client-picker-lista button.activa { background: #f0f4f8; }

.client-picker-separador {
  padding: 8px 10px 4px;
  color: #999;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-top: 1px solid #eee;
  margin-top: 4px;
}

.client-picker-nuevo {
  padding: 8px 10px;
  color: #777;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ClientPicker.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF,iBAAiB,kBAAkB,EAAE;AACrC,uBAAuB,WAAW,EAAE;;AAEpC;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,0BAA0B,SAAS,EAAE;;AAErC;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oDAAoD,mBAAmB,EAAE;;AAEzE;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* Desplegable de clientes. Acotado a .client-picker: el CSS de CRA es global. */\n.client-picker { position: relative; }\n.client-picker input { width: 100%; }\n\n.client-picker-lista {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  max-height: 260px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 4px;\n  list-style: none;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n}\n\n.client-picker-lista li { margin: 0; }\n\n.client-picker .client-picker-lista button {\n  display: block;\n  width: 100%;\n  padding: 7px 10px;\n  border: none;\n  border-radius: 6px;\n  background: none;\n  color: #222;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.client-picker .client-picker-lista button.activa { background: #f0f4f8; }\n\n.client-picker-separador {\n  padding: 8px 10px 4px;\n  color: #999;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border-top: 1px solid #eee;\n  margin-top: 4px;\n}\n\n.client-picker-nuevo {\n  padding: 8px 10px;\n  color: #777;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
